import { IonCardContent } from '@ionic/react';
import { useState } from 'react';

import Activation from './RegisterForms/Activation';
import Register from './RegisterForms/Register';

interface Props {
    loginSuccess: any
}

const RegisterForm: React.FC<Props> = (props) => {
    const [showConfirm, setShowConfirm] = useState(false);
    const [uid, setUid] = useState("");
    const [remainedTime, seRemainedTime] = useState(0);

    const registerDoneHandler = (uid: string, remained: number) => {
        setUid(uid);
        seRemainedTime(remained);
        setShowConfirm(true);
    }

    const activationDoneHandler = () => {
        setShowConfirm(false);
    }

    return !showConfirm ?
        <Register registerDone={registerDoneHandler} /> :
        <Activation uid={uid} remainTime={remainedTime} activationDone={activationDoneHandler} loginSuccess={props.loginSuccess} />
}

export default RegisterForm